module.exports = __webpack_public_path__ + "static/placeholder1-70630e2965a7f557800eb6838a575a7b.png";